import * as _ from 'lodash'
import React from 'react';
import * as contractorActions from '../contractorActions';
import componentServices from '../componentServices';
import util from '../util';
import globalRelay from '../globalRelay';
import * as employeeActions from '../employeeActions';
import { sortableComponent } from './sharedComponents';
import * as actions from '../actions';
import JobCostSummary from '../models/jobCostSummary';
import NewTemplateModal from './jobCostCreateModal';
import { getCollection, ModelCollection } from 'Scripts/store';
import { IJobCost } from '../models/jobCostModel';

class TemplateTableRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick (e) {
		e.preventDefault();
		componentServices.router.pushHistory(componentServices.router.pushPathSegment(this.props.jobCost.key));
	}

	render () {
		const { jobCost, employee } = this.props;
		const globalConfig = globalRelay.config!.withVariant(jobCost.companyVariant);
		// const employee = employeeActions.getEmployeeByUserKey(jobCost.modifiedOrCreatedById);
		const badgeRow = globalRelay.config!.variants.length > 1 && globalConfig.badge ? <td><span className="badge" style={{ backgroundColor: globalConfig.badge.color }}><span>{ globalConfig.badge.label }</span></span></td> : null;

		return (
			<tr onClick={this.handleClick}>
				<td />
				<td>{jobCost.name}</td>
				<td>{util.formatAsCurrency(jobCost.totalCost)}</td>
				<td>{ employee ? employee.fullName : 'Unknown' }</td>
				<td>{util.dateHelper.formatDate(jobCost.dateLastModified, { userFriendly: true })}</td>
				{ badgeRow }
				<td />
				<td />
			</tr>
		);
	}
}

const TemplateTable = sortableComponent(class InnerTable extends React.Component<any,any> {
	handleClick (path, e) {
		e.preventDefault();
		this.props.updateSort(path);
	}

	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}

	render () {
		const { list, store, ...childProps } = this.props;
		const rows:JSX.Element[] = [];
		const badgeRow = globalRelay.config!.variants.length > 1 ? <td /> : null;

		list.forEach((jobCost) => {
			const userKey = jobCost.lastModifiedById??jobCost.createdById;
			const employee = employeeActions.getEmployeeByUserKey(userKey);
			
			if (!employee && userKey) {
				employeeActions.fetchEmployee({ userKey });
			}

			rows.push(<TemplateTableRow jobCost={jobCost} key={jobCost.key} employee={ employee } {...childProps} />);
		});

		return (
			<table className="sortable interactive" cellPadding="0" cellSpacing="0">
				<thead>
					<tr>
						<td />
						<td className={this.getClassName('name')} onClick={this.handleClick.bind(this, 'name')}>Model Name</td>
						<td className={this.getClassName('cost')} onClick={this.handleClick.bind(this, 'cost')}>Cost</td>
						<td className={this.getClassName('modifiedBy')} onClick={this.handleClick.bind(this, 'modifiedBy')}>Modified by</td>
						<td className={this.getClassName('modifiedOn')} onClick={this.handleClick.bind(this, 'modifiedOn')}>Modified on</td>
						{ badgeRow }
						<td />
						<td />
					</tr>
				</thead>
				<tbody>
					{ rows }
				</tbody>
			</table>
		);
	}
});

type ListTemplate = IJobCost & { totalCost: number, workAreaCount: number };

export default class ContractorTemplateList extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleAddTemplateClick = this.handleAddTemplateClick.bind(this);
	}

	// UNSAFE_componentWillReceiveProps (nextProps) {
	// 	this.setState(this.getStateFromProps(nextProps));
	// }

	componentDidMount(): void {
		const { contractor } = this.props;

		if(contractor) {
			contractorActions.fetchContractor({ key: contractor.key });
		}
	}

	getTemplates (props) {
		const contractor = props.contractor;
		const jobCosts = getCollection({ store: componentServices.store, collection: ModelCollection.jobCosts} );
		const templates:ListTemplate[] = [];

		if (jobCosts && jobCosts.size) {
			jobCosts
				.filter(jc => jc.contractorKey === contractor.key)
				.forEach(jc => {
					const result = jc.toDocument() as ListTemplate;
					const summary = new JobCostSummary(jc, 0);
					summary.buildItems();

					result.totalCost = summary.grandTotalSell;
					result.workAreaCount = (result.workAreas) ? (result.workAreas as any).length : 0;
					result.companyVariant = jc.companyVariant;

					templates.push(result);
				});
		}

		return templates;
	}

	handleAddTemplateClick () {
		// const { contractorKey } = this.state;
		const contractor = this.props.contractor;
		const globalConfig = globalRelay.config!;

		if (globalConfig.variants.length > 1) {
			actions.pushModal({
				component: (<NewTemplateModal close={ actions.popModal} contractorKey={contractor.key} contractorTemplates={ [] } />)
			});
		}
		else {
			componentServices.router.pushHistory(componentServices.router.pushPathSegments(util.generateGuid(), 'setup'));
		}

		// e.preventDefault();
		// // creates a new key for a potential new job cost
		// componentServices.router.pushHistory(componentServices.router.pushPathSegment(util.generateGuid()));
	}

	render () {
		//const contractorKey = componentServices.routeParams.contractorkey;
		//const templates = this.state.templates;

		return (
			<section>
				<div className="inner">
					<TemplateTable list={ this.getTemplates(this.props) } initialSortKey="label" store={ this.props.store }/>
					<button className="iconLabel addTemplate" onClick={this.handleAddTemplateClick} ><span>New Model</span></button>

				</div>
			</section>
		);
	}
}